import type { ReactNode } from 'react';
import { SiteShell } from './SiteShell';
import type { SitePageLayoutProps } from './SitePageLayout';

type SettingsPageLayoutProps = Pick<
  SitePageLayoutProps,
  'title' | 'description' | 'back' | 'actions' | 'toolbar' | 'alerts'
> & {
  children: ReactNode;
  /** Skip the default feed-card wrapper when children already use form-card chrome. */
  bare?: boolean;
};

/** Standard shell for account, admin, and form-heavy pages. */
export function SettingsPageLayout({ children, bare, ...page }: SettingsPageLayoutProps) {
  return (
    <SiteShell {...page}>
      {bare ? children : <div className="feed-card settings-page">{children}</div>}
    </SiteShell>
  );
}
